import React from "react";
import "./index.scss";
import { Flex, Table, Typography } from "antd/lib";
import { IPaymentSummary } from "../../../../interfaces/dashboard";
import { formatEuropeanCurrencyIntl, formatNumber } from "../../../../utils/helper";
const { Text } = Typography;

interface PaymentsSummaryProps {
  data: IPaymentSummary;
  loading?: boolean;
}

const statusClasses: Record<string, string> = {
  Unmatched: "text-error",
  Matched: "text-success",
  "Ready to Export": "text-success",
  Exported: "text-success",
  Completed: "text-success",
};

const PaymentsSummary: React.FC<PaymentsSummaryProps> = ({
  data,
  loading = false,
}) => {

  const paymentData = [
    { key: "group1", type: "group", status: "Pre-export Payment" },
    {
      key: "1",
      status: "Unmatched",
      volume: data.unmatchedVolume,
      amount: data.unmatchedAmount,
    },
    {
      key: "2",
      status: "Matched",
      volume: data.matchedVolume,
      amount: data.matchedAmount,
    },
    {
      key: "3",
      status: "Ready to Export",
      volume: data.readyToExportVolume,
      amount: data.readyToExportAmount,
    },
    {
      key: "subtotal1",
      type: "subtotal",
      status: "Pre-export Subtotal",
      volume: data.preExportVolume,
      amount: data.preExportAmount,
    },
    { key: "group2", type: "group", status: "Exported Payments" },
    {
      key: "4",
      status: "Exported",
      volume: data.exportedVolume,
      amount: data.exportedAmount,
    },
    {
      key: "subtotal2",
      type: "subtotal",
      status: "Export Subtotal",
      volume:
        (data.preExportVolume || 0) + (data.exportedVolume || 0),
      amount:
        (data.preExportAmount || 0) + (data.exportedAmount || 0),
    },
    {
      key: "5",
      status: "Completed",
      volume: data.completedVolume,
      amount: data.completedAmount,
    },
    {
      key: "total",
      type: "total",
      status: "Total in CHIP",
      volume: data.totalVolume,
      amount: data.totalAmount,
    },
  ];

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text: string, record: any) => {
        if (
          record.type === "group" ||
          record.type === "subtotal" ||
          record.type === "total"
        ) {
          return <Text strong>{text}</Text>;
        }
        const className = statusClasses[text] || "";
        return <span className={`status-label ${className}`}>{text}</span>;
      },
    },
    {
      title: "Volume",
      dataIndex: "volume",
      key: "volume",
      align: "right" as const,
      render: (val?: number) => {
        if (val === undefined) return null;
        if (val === 0) return '---';
        return <Text>{formatNumber(val)}</Text>;
      },
    },
    {
      title: "Total Amount (GBP)",
      dataIndex: "amount",
      key: "amount",
      align: "right" as const,
      render: (val?: number) => {
        if (val === undefined) return null;
        if (val === 0) return '---';
        return <Text>{formatEuropeanCurrencyIntl(val)}</Text>;
      },
    }
  ];

  return (
    <Flex
      className="payments-summary"
      justify="center"
      wrap={true}
      style={{ width: "100%", borderRadius: 12 }}
    >
      <Table
        dataSource={paymentData}
        columns={columns}
        pagination={false}
        rowKey="key"
        loading={loading}
        size="small"
        className="table-fm table-payments-fm"
        rowClassName={(record) => {
          if (record.type === "group") return "group-row";
          if (record.type === "subtotal") return "subtotal-row";
          if (record.type === "total") return "total-row";
          return "normal-row";
        }}
      />
    </Flex>
  );
};

export default React.memo(PaymentsSummary);
